import Component from './ManageUsers';

export default Component;
